wbApp.filter('franchiseCentralFlt', ['tenantInfo', function (tenantInfo) {
    return function (input) {
        if (input) {            
            var franchiseCentral = _.find(tenantInfo.franchiseCentrals, { tenantID: input });
            if (franchiseCentral) {
                return franchiseCentral.alias;
            }
        }
    
        return '';
    };
}]);